import { apiFetch } from "./api";

export const getPendingByQuarter = async (quarterly) => {
    const obj = {
        method: 'POST',
        body: {
            quarterly,
            option: 'get_pending_by_quarter',
        }
    }

    const response = await apiFetch(obj);

    return response;
};
